<template>
  <v-layout column align-center justify-start class="relative">
	<div style="width: 100%;height: 130px;background: rgb(236, 236, 236);position: absolute;top: 19px;">
		<v-icon style="font-size: 131px;color: rgb(250, 251, 251);position: absolute;right: 9px;bottom: -13px;">library_books</v-icon>
	</div>
	<v-progress-linear v-if="initialLoading" v-slot:progress color="primary" indeterminate></v-progress-linear>


	<div v-if="files.length > 0" style="width:80%">

	<div class="grey--text text--darken-2" style="position:relative;z-index:2;margin-top:75px;padding-left: 2px;">
		{{ fileHeader }}
	<v-tooltip bottom>
      <v-btn slot="activator" color="primary" icon flat @click='readFiles' :disabled="filesLoading" style="margin-left: 2px;position: relative;top: -2px;">
        <v-icon class="icon-button-shadow">refresh</v-icon>
      </v-btn>
        <span>Refresh</span>
      </v-tooltip>
	</div>

	<v-data-table :headers="headers" :items="filesPaged" :loading="filesLoading" :disable-initial-sort="true" class="myFilesTable" style="position:relative;z-index:2">
	<!--<v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>-->
      <template slot="items" slot-scope="props">

        <td>
        	<v-tooltip bottom>
        		<b slot="activator">{{ props.item.fileName }}</b>
        		<span>{{props.item.fileNameFull}}</span>
			</v-tooltip>
        </td>

        <td>{{ props.item.fileType }}</td>
        <td>{{ props.item.date }}</td>
        <td>{{ props.item.expirationDate }}</td>

        <td>
        <v-icon v-if="props.item.expired" class="pink--text text--darken-2">timer_off</v-icon>
        <v-icon v-else-if="props.item.status=='Ready'" color="#80c310">trip_origin</v-icon>
        <v-icon v-else class="amber--text text--lighten-1">trip_origin</v-icon>
        {{ props.item.status }}
        </td>
        <td>{{ props.item.words }}</td>
        <td>
        	<v-tooltip bottom>
        		<v-icon slot="activator" color="primary" @click="viewGeneratedFileScript(props.item.fileName, props.item.scriptText)" style="vertical-align:middle">pageview</v-icon>
        		<span>View Script</span>
			</v-tooltip>
        	"{{toEllipses(props.item.scriptText, 16)}}"
        </td>
        <td>

			<v-tooltip bottom>
				<v-btn :disabled="props.item.status!='Ready'||props.item.expired" :href="props.item.link" slot="activator" icon color="primary--text"><v-icon :class="props.item.expired ?``:`icon-button-shadow`">save_alt</v-icon></v-btn>
				<span>Download {{ props.item.fileName }}</span>
			</v-tooltip>
			<v-tooltip bottom>
				<lingo_audio :disabled="props.item.expired" slot="activator" :play_button_class="(props.item.status!='Ready'||props.item.expired) ?``:`icon-button-shadow`" :play_button_color="`primary--text`" :label_class="``" :label_text="``" :file="props.item.link"></lingo_audio>
				<span>Play {{ props.item.fileName }}</span>
			</v-tooltip>
			<v-tooltip bottom>
				<v-btn slot="activator" icon color="primary--text"><v-icon class="icon-button-shadow">delete_outline</v-icon></v-btn>
				<span>Delete {{ props.item.fileName }}</span>
			</v-tooltip>
        </td>
      </template>
    </v-data-table>
    <div style="text-align:center">
		<v-pagination v-model="page" :length="calculatePages" total-visible="6" :disabled="filesLoading" class="mt-2"></v-pagination>
	</div>
    </div>

    <!-- no files message -->
    <div v-else style="margin-top: 79px;position: relative;z-index: 5" v-show="!filesLoading">
		You have no files yet. <router-link to="/app/audio_generator">Generate</router-link> one now.
    </div>


    <!-- script dialog -->
    <v-dialog v-model="scriptDialog" width="550" persistent>

      <v-card class="pa-3 pb-1">
        <v-card-title class="headline" primary-title>Script for File '{{scriptDialogFileName}}'</v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-container grid-list-xl>

              <v-layout wrap justify-space-between>
                <v-flex xs12>
                  <v-textarea outline readonly v-model="scriptDialogScript"></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="justify-space-between">
          <v-btn flat @click="scriptDialog=false">Close</v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>

 </v-layout>
</template>

<style>

.v-datatable__actions {
	display:none;
}

.v-table tbody tr:hover {
	background:transparent !important;
}

.v-datatable thead th.column.sortable {
	font-size: 1.2rem;
    font-weight: 300;
    color:#757575;
}

td {
font-size: 1.05rem !important;
font-weight: 300 !important;
padding-right:0px !important;
}

.v-table thead tr:first-child{
	border-bottom: 1px solid #e7eaed !important;
}

.audio-player-container {
	display:inline;
}
</style>

<script>

import AudioGeneratorService from '../service/audioGeneratorService';
import lingo_audio from './AudioPlayer';

  export default {
    name: 'lingo_my_files',
    data () {
      return {
      page:1,
      filesStart: 0,
      fileEnd: 0,
      //fileCount: 'Loading...',
      fileHeader: null,
      filesLoading: true,
      initialLoading: true,
      scriptDialog: false,
      scriptDialogFileName: null,
      scriptDialogScript: null,
      headers: [
        { text: 'Name', align: 'left', value: 'name' },
        { text: 'Type', align: 'left', value: 'type' },
        { text: 'Created', align: 'left', value: 'date' },
        { text: 'Expiration', align: 'left', value: 'expiration' },
        { text: 'Status', align: 'left', value: 'status' },
        { text: 'Words', align: 'left', value: 'chars' },
        { text: 'Script', align: 'left', value: 'scriptText' },
        { text: '', align: 'left', value: 'actions' }
      ],
      files: [],
      filesPages: [],
      maxRowsPerPage: 6

      }
    },
  methods: {
  	toEllipses (text, maxLength) {
  		return (text.length > maxLength) ? text.substr(0, maxLength - 1) + '...' : text;
  	},
	extractLocalizedDateTime (dateString) {
		// expected input .../date/ -> "eu-west-1:3c11df87-20b1-4b2e-9525-e2512c450774/2019-03-17T15.34.58.460/order_fulfillment.json"
		var dateFull = dateString.split(/\//)[1];
		var dateFullUTCString = dateFull.replace('.', ':').replace('.', ':') + 'Z';
		return this.localizeDate(new Date(dateFullUTCString));
	},
	localizeDate (dateUTC) {
		return dateUTC.getFullYear() + '/' + this.zeroPaddedTwoDigitNumber(dateUTC.getMonth() + 1) + '/' + this.zeroPaddedTwoDigitNumber(dateUTC.getDate())
			 + ' ' + this.zeroPaddedTwoDigitNumber(dateUTC.getHours()) + ":" + this.zeroPaddedTwoDigitNumber(dateUTC.getMinutes());
	},
	localizeExpirationTimestamp (timestamp) { // format: 2019/10/12 19:51
		var expirationDate = this.expirationTimestampToDate(timestamp);
		var expirationDateUTCString = expirationDate.getFullYear() + '-' +  this.zeroPaddedTwoDigitNumber(expirationDate.getMonth() + 1) + '-'
			+  this.zeroPaddedTwoDigitNumber(expirationDate.getDate()) + 'T' +
			this.zeroPaddedTwoDigitNumber(expirationDate.getHours()) + ':' + this.zeroPaddedTwoDigitNumber(expirationDate.getMinutes()) + ':00.000Z';
		return this.localizeDate(new Date(expirationDateUTCString));
	},
	zeroPaddedTwoDigitNumber(number) {
		return ("0" + number).slice(-2);
	},
	expirationTimestampToDate (dateString) { // format: 2019/10/12 19:51
		var dateStringSplit = dateString.split(/ /);

		var dateSplit = dateStringSplit[0].split(/\//);
		var year = dateSplit[0];
		var month = dateSplit[1];
		var day = dateSplit[2];

		var timeSplit = dateStringSplit[1].split(/:/);
		var hour = timeSplit[0];
		var minute = timeSplit[1];

		var expirationDate = new Date();
  		expirationDate.setYear(year);
  		expirationDate.setMonth(month - 1);
		expirationDate.setDate(day);
  		expirationDate.setHours(hour);
  		expirationDate.setMinutes(minute);
  		return expirationDate;
	},
	calculateExpired (dateString) {
		return Date.now() - this.expirationTimestampToDate(dateString).getTime() > 0;
	},
	readFiles () {
		var that = this;
		that.page = 1;
		that.filesLoading = true;
		AudioGeneratorService.readMyFiles(function(filesArray) {
			that.filesLoading = false;
			that.initialLoading = false;
			//that.fileCount = 'You have ' + filesArray.length + (filesArray.length > 1 ? " files" : " file");

			var _files = [];
			for (var f = 0; f < filesArray.length; f ++) {
				var obj = {};
				obj.fileName = that.toEllipses(filesArray[f].fileName, 18);
				obj.fileType = filesArray[f].fileType;
				obj.fileNameFull = filesArray[f].fileName;
				obj.date = that.extractLocalizedDateTime(filesArray[f].fileKey);
				obj.expiration = filesArray[f].fileExpiresAfter ? filesArray[f].fileExpiresAfter : 'N/A';
				obj.expirationDate = filesArray[f].fileExpiresAfter ? that.localizeExpirationTimestamp(filesArray[f].fileExpiresAfter) : 'N/A';
				obj.expired = filesArray[f].fileExpiresAfter ? that.calculateExpired(filesArray[f].fileExpiresAfter) : false;
				obj.status = filesArray[f].fileCompleted ? 'Ready' : 'Running';
				if (obj.expired) {
					obj.status = 'Expired';
				}
				obj.link = filesArray[f].fileLink ? filesArray[f].fileLink : '#';
				obj.words = filesArray[f].fileWords ? filesArray[f].fileWords : '?';
				obj.scriptText = filesArray[f].scriptText;
				_files[f] = obj;
			}
			// sort by date
			_files.sort((a,b) => (b.date > a.date) ? 1 : ((a.date > b.date) ? -1 : 0));
			that.files = _files;
			that.pageFiles(that.page);

		});
		},
		viewGeneratedFileScript (fileName, scriptText) {
			this.scriptDialogFileName = fileName;
			this.scriptDialogScript = scriptText;
			this.scriptDialog = true;
		},
		pageFiles (currentPage) {
			this.filesStart = (currentPage - 1) * this.maxRowsPerPage;
			this.fileEnd = (this.files.length - this.filesStart) >= this.maxRowsPerPage ? this.filesStart + this.maxRowsPerPage : this.files.length;
			this.filesPaged = this.files.slice(this.filesStart, this.fileEnd);
			this.updateFilesHeader();
		},
		updateFilesHeader() {
			var totalCount = this.files.length;
			this.fileHeader = "Showing " + (this.filesStart + 1) + " to " + this.fileEnd + " of " + totalCount + " files";
		}
    },
    watch: {
    	page: {
        	handler: function(newPage, oldPage) {
           		this.pageFiles(newPage);
        	},
        	deep: true
    	}
    },
    mounted () {
		this.readFiles();
	},
	computed:  {
		calculatePages () {
			if (!this.files) {
				return 0;
			}
    		return Math.ceil(this.files.length / this.maxRowsPerPage);
    	}
	},
	components : {
		lingo_audio
	}
  }
</script>
